import { render, staticRenderFns } from "./tree-selector.vue?vue&type=template&id=54bfe84a"
import script from "./tree-selector.vue?vue&type=script&lang=js"
export * from "./tree-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports